import {
    ADD_CENTRO_USUARIO,
    DELETE_CENTRO_USUARIO,
    MODIFY_CENTRO_USUARIO
} from '../constants/action_types';

export function addUsuarioCentro(centro) {
    return (dispatch, getState) => {
        dispatch({ type: ADD_CENTRO_USUARIO, payload: centro });
    };
};

export function modifyUsuarioCentro(centro) {
    return (dispatch, getState) => {
        dispatch({ type: MODIFY_CENTRO_USUARIO, payload: centro });
    };
};


export function removeUsuarioCentro(centro) {
    return (dispatch, getState) => {
        dispatch({ type: DELETE_CENTRO_USUARIO, payload: centro });
    };
};